import { render, staticRenderFns } from "./SendMessageDropdown.vue?vue&type=template&id=14935ad6&scoped=true"
import script from "./SendMessageDropdown.vue?vue&type=script&lang=js"
export * from "./SendMessageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14935ad6",
  null
  
)

export default component.exports